var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.092 0.363963C13.4825 0.754487 13.4825 1.38765 13.092 1.77818L8.14295 6.72721L13.092 11.6777C13.4825 12.0682 13.4825 12.7014 13.092 13.0919C12.7015 13.4824 12.0683 13.4824 11.6778 13.0919L6.72873 8.14143L1.77828 13.0919C1.38776 13.4824 0.754592 13.4824 0.364068 13.0919C-0.0264564 12.7014 -0.0264564 12.0682 0.364068 11.6777L5.31452 6.72722L0.364071 1.77817C-0.0264531 1.38764 -0.026453 0.75448 0.364071 0.363956C0.754596 -0.0265688 1.38776 -0.0265691 1.77829 0.363955L6.72873 5.313L11.6778 0.363963C12.0683 -0.0265614 12.7015 -0.0265614 13.092 0.363963Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.722bab3282443d41da412cb16ca8f647.svg";
export { ForwardRef as ReactComponent };